import { NavLink } from 'react-router-dom';
import { BarChart3, CalendarDays, FileText, SlidersHorizontal, Timer, type LucideIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTimeOffNewCount } from '../hooks/useTimeOffNotifications';
import { cn } from '../lib/cn';

interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  needsManage?: boolean;
}
const NAV: NavItem[] = [
  { to: '/tracker', label: 'Tracker', icon: Timer },
  { to: '/dashboard', label: 'Dashboard', icon: BarChart3 },
  { to: '/reports', label: 'Reports', icon: FileText },
  { to: '/timeoff', label: 'Time Off', icon: CalendarDays },
  { to: '/manage', label: 'Manage', icon: SlidersHorizontal, needsManage: true },
];

export function Sidebar() {
  const { permissions } = useAuth();
  const timeOffNew = useTimeOffNewCount();
  return (
    <aside className="hidden w-60 shrink-0 flex-col border-r border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800 lg:flex">
      <div className="flex items-center gap-2 px-5 py-5">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#FF5A3C]">
          <Timer size={18} className="text-white" />
        </span>
        <span className="text-lg font-extrabold tracking-tight">
          <span className="text-[#FF5A3C]">Food</span>
          <span className="text-ink dark:text-slate-100">Styles</span>
        </span>
      </div>
      <nav className="flex-1 space-y-1 px-3 py-2">
        {NAV.filter((n) => !n.needsManage || permissions?.manage).map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold transition-colors',
                isActive
                  ? 'bg-[#FF5A3C]/10 text-[#D8341A] dark:bg-[#FF5A3C]/20 dark:text-[#FF8A6B]'
                  : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700',
              )
            }
          >
            <n.icon size={18} />
            {n.label}
            {n.to === '/timeoff' && timeOffNew > 0 && (
              <span
                title={`${timeOffNew} new time-off request${timeOffNew > 1 ? 's' : ''}`}
                className="ml-auto inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#FF5A3C] px-1.5 text-[10px] font-bold text-white"
              >
                {timeOffNew}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="px-5 py-4 text-[11px] text-slate-400 dark:text-slate-500">All times in UK time (Europe/London)</div>
    </aside>
  );
}
